var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-4 custom-callout rounded",
      attrs: { "border-color": "primary-2", "has-toggle": false }
    },
    [
      _c(
        "div",
        { staticClass: "py-2" },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("icon-view", {
                staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
                attrs: {
                  gradient: false,
                  icon: "fas fa-exchange-alt mb-1",
                  "icon-background": "#ff7058",
                  "icon-color": "white",
                  "icon-size": "16px",
                  title: _vm.title
                }
              })
            ],
            1
          ),
          _c("validation-observer", { ref: "statusCardObserver" }, [
            _c("div", { staticClass: "row my-3" }, [
              _c(
                "div",
                { staticClass: "col-md-3 col-sm-12 mr-md" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                "custom-error-msg": "El estatus es requerido.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Estatus:",
                                options: _vm.statuses,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onStatusChange },
                              model: {
                                value: _vm.model.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "status", $$v)
                                },
                                expression: "model.status"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-between mt-3 mb-0 pr-3"
              },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12 px-0" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "custom-error-msg":
                                    "El comentario es requerido.",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Comentario:",
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.model.comment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "comment", $$v)
                                  },
                                  expression: "model.comment"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pl-0 pt-4" },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-times-circle",
                        text: "Cancelar",
                        variant: "outline-danger mr-3 pl-3 pr-4"
                      },
                      on: { click: _vm.onClose }
                    }),
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-arrow-alt-circle-right",
                        text: "Continuar",
                        variant: "success pl-3 pr-3"
                      },
                      on: { click: _vm.onContinue }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }